<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>Панель керування TalentSearch.Pro</mat-card-title>
      <mat-card-subtitle>Будь ласка, увійдіть для продовження</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Електронна пошта</mat-label>
          <input matInput formControlName="email" placeholder="Введіть електронну пошту" required />
          @if (getFormControl('email').invalid && (getFormControl('email').dirty || getFormControl('email').touched)) {
            <mat-error>Електронна пошта є обов'язковою</mat-error>
          }
          @if (getFormControl('email').invalid && getFormControl('email').errors?.['email']) {
            <mat-error>Неправильна електронна пошта</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Пароль</mat-label>
          <input matInput type="password" formControlName="password" placeholder="Введіть пароль" required />
          @if (
            getFormControl('password').invalid &&
            (getFormControl('password').dirty || getFormControl('password').touched)
          ) {
            <mat-error>Пароль є обов'язковим для входу</mat-error>
          }
        </mat-form-field>

        @if (error) {
          <div class="error-message">{{ error }}</div>
        }

        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="loading || loginForm.invalid"
          class="full-width"
        >
          @if (loading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            Login
          }
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
